if (!customElements.get('video-with-overlay')) {
  class VideoWithOverlay extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.video = this.querySelector('video');
      this.overlay = this.querySelector('.video-overlay');
      this.playButton = this.querySelector('.video-custom-button');

      this.overlay.addEventListener('click', () => this.toggleVideo());
      this.playButton.addEventListener('click', () => this.toggleVideo());
      this.video.addEventListener('click', () => this.toggleVideo());
    }

    toggleVideo() {
      this.video.paused ? this.video.play() : this.video.pause();
      this.playButton.classList.toggle('hidden');
      this.overlay.classList.toggle('hidden');
    }
  }
  customElements.define('video-with-overlay', VideoWithOverlay);
}
